<template>
  <div
    class="c-library-book-options"
    :style="`top: calc(180px - ${cover}px)`">
    <button
      class="c-library-book-options__toggle"
      ref="toggler"
      aria-haspopup="true"
      :aria-expanded="`${open}`"
      :aria-label="`${$t(getOptionName)}`"
      @click="toggleOpen"
    >
      <span class="c-library-book-options__dot"></span>
      <span class="c-library-book-options__dot"></span>
      <span class="c-library-book-options__dot"></span>
    </button>
    <div
      v-show="open"
      v-click-outside="{
        exclude: ['toggler'],
        handler: 'close'
      }"
      class="c-library-book-options__tooltip"
    >
      <button class="c-library-book-options__action" @click="actionClick">
        <span class="c-library-book-options__action-text">
          {{ $t(getOptionName) }}
        </span>
        <icon-download v-if="status === 'ONLINE'" color="#fff"></icon-download>
        <icon-archive v-if="status === 'OFFLINE_READY'" color="#fff"></icon-archive>
      </button>
    </div>
  </div>
</template>

<script>
import IconArchive from '@/assets/svg/Archive'
import IconDownload from '@/assets/svg/DownloadLibraryBook'

export default {
  name: 'LibraryBookOptions',

  props: {
    status: String,
    cover: Number
  },

  data() {
    return {
      open: false
    }
  },

  components: {
    'icon-archive': IconArchive,
    'icon-download': IconDownload
  },

  computed: {
    getOptionName() {
      if (this.status === 'OFFLINE_READY') {
        return 'ARCHIVE'
      } else {
        return 'DOWNLOAD'
      }
    },

    canToggle() {
      return this.status === 'OFFLINE_READY' || this.status === 'ONLINE'
    }
  },

  methods: {
    toggleOpen() {
      if (this.canToggle) {
        this.open = !this.open
      }
    },

    close() {
      this.open = false
    },

    actionClick() {
      this.$emit('action-click')
      this.close()
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-library-book-options {
  position: absolute;
  left: calc(50% + 60px);
}

.c-library-book-options__toggle {
  @include btnReset();
  display: flex;
  width: 1.5rem;
  flex-direction: column;
  align-items: center;

  cursor: pointer;
  @include a11yOutline();
}

.c-library-book-options__dot {
  width: 0.25rem;
  height: 0.25rem;
  background: $light-grey-blue;
  margin-bottom: 0.2rem;
  border-radius: 50%;

  .c-library-book-options__toggle:hover & {
    background: $dark-blue;
  }
}

.c-library-book-options__tooltip {
  position: absolute;
  background: $dark-blue;
  border-radius: 0.5rem;
  top: calc(-100% - 1.4rem);

  left: 50%;
  transform: translateX(-50%);

  &::after {
    z-index: -1;
    position: absolute;
    top: 98.1%;

    left: 50%;
    transform: translateX(-50%);
    content: '';
    width: 0;
    height: 0;
    border-top: solid 0.5rem $dark-blue;
    border-left: solid 0.5rem transparent;
    border-right: solid 0.5rem transparent;
  }
}

.c-library-book-options__action {
  @include btnReset();
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 0.875em;
  color: $white;
  padding: 0.4rem 1rem;

  cursor: pointer;

  > svg {
    margin-left: 0.5rem;
  }

  @include a11yOutline();
}

.c-library-book-options__action-text {
  white-space: nowrap;
}
</style>
